"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionPhoto = void 0;
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const ImageEditorDialog_1 = __importDefault(require("@opsbase/web-image/ImageEditorDialog"));
const ImageTakerDialog_1 = __importDefault(require("@opsbase/web-image/ImageTakerDialog"));
const ImageUploadButton_1 = __importDefault(require("@opsbase/web-image/ImageUploadButton"));
const ImageViewer_1 = __importDefault(require("@opsbase/web-image/ImageViewer"));
const useManyImages_1 = __importDefault(require("@opsbase/web-image/useManyImages"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
function OpPerformQuestionPhoto(props) {
    var _a;
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    let { allowUploadPhoto, allowCapturePhoto } = rule;
    // NOTE: In some old forms, it is possible that both the above are false which
    // Basically renders the question unusable... the following line fixes this
    if (!allowCapturePhoto && !allowUploadPhoto)
        allowCapturePhoto = true;
    const [showImageTaker, setShowImageTaker] = (0, react_1.useState)(false);
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const showUploadOrTake = !viewMode;
    const showUpload = showUploadOrTake && !!allowUploadPhoto && !viewMode;
    const showOr = showUploadOrTake && !!allowUploadPhoto && !!allowCapturePhoto;
    const showTake = showUploadOrTake && !!allowCapturePhoto;
    const showButtons = showUpload || showTake || showOr;
    const handleClickTake = (0, react_1.useCallback)(() => setShowImageTaker(true), []);
    const handleImagesChange = (0, react_1.useCallback)((photos) => {
        doChangeAnswer(Object.assign(Object.assign({}, answer), { photos: photos === null || photos === void 0 ? void 0 : photos.map(z => z.fileName).join(',') }));
    }, [doChangeAnswer, answer]);
    const { deleteImage, addImage, handleAccept, handleCancel, hideEditor, resolvedImages, } = (0, useManyImages_1.default)({
        photos: answer.photos,
        onImagesChange: handleImagesChange,
    });
    const len = ((_a = resolvedImages === null || resolvedImages === void 0 ? void 0 : resolvedImages.length) !== null && _a !== void 0 ? _a : 0) - 1;
    const handleAcceptTake = (0, react_1.useCallback)(v => {
        addImage(v);
        setShowImageTaker(false);
    }, [addImage]);
    const handleCancelEditor = (0, react_1.useCallback)(() => {
        setShowImageTaker(false);
        handleCancel();
    }, [handleCancel]);
    return (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props),
            react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true, padding: true },
                react_1.default.createElement(ImageViewer_1.default, { resolvedImages: resolvedImages, size: 200, editable: !viewMode, onDeleteImage: deleteImage }),
                !!showButtons && (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, padding: true },
                    react_1.default.createElement(Pane_1.default, { grow: true }),
                    !!showUpload && (react_1.default.createElement(ImageUploadButton_1.default, { onUploading: setUploading, onUpload: addImage })),
                    !!showOr && react_1.default.createElement(Text_1.default, null, "or"),
                    !!showTake && (react_1.default.createElement(Button_1.default, { disabled: uploading, style: { minWidth: 132 }, label: lib_i18n_1.default.t('take-photo'), onClick: handleClickTake })),
                    react_1.default.createElement(Pane_1.default, { grow: true })))),
            !hideEditor && (react_1.default.createElement(ImageEditorDialog_1.default, { dataUrl: (_a = resolvedImages[len]) === null || _a === void 0 ? void 0 : _a.imageData, onCancel: handleCancelEditor, onAccept: handleAccept })),
            !!showImageTaker && (react_1.default.createElement(ImageTakerDialog_1.default, { onCancel: handleCancelEditor, onAccept: handleAcceptTake }))));
    }, [
        props,
        viewMode,
        resolvedImages,
        deleteImage,
        showButtons,
        showUpload,
        addImage,
        showOr,
        showTake,
        uploading,
        handleClickTake,
        hideEditor,
        len,
        handleCancelEditor,
        handleAccept,
        showImageTaker,
        handleAcceptTake,
    ]);
}
exports.OpPerformQuestionPhoto = OpPerformQuestionPhoto;
exports.default = OpPerformQuestionPhoto;
